import dayjs from 'dayjs'
import { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useLingui } from '@lingui/react'
import { t } from '@lingui/macro'

import { Stack } from '@mui/material'

import useMetadataTitle from '@/hooks/useMetadataTitle'

import ChimeMeeting from '@/pages/diagnostic/containers/ChimeMeeting'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { joinMeeting, leaveMeeting } from '@/redux/reducers/consultation.reducer'

import { isStaff } from '@/utils/type-guards'

const VisioConferencePage = () => {
  useLingui()
  const [searchParams] = useSearchParams()
  const consultationId = searchParams.get('consultationId')
  const roomId = searchParams.get('roomId')
  const dispatch = useAppDispatch()

  const authUser = useAppSelector(selectAuthUser)

  useMetadataTitle(t`VisioConference`)

  const handleJoinMeeting = useCallback(() => {
    if (!isStaff(authUser)) return

    const userId = `${authUser._id}-${dayjs().unix()}`

    if (consultationId) {
      dispatch(joinMeeting({ roomOrConsultationId: consultationId, userId, meetingType: 'visioConference' }))
      return
    }

    if (authUser.status === 'MEDECIN' && roomId) {
      dispatch(joinMeeting({ roomOrConsultationId: roomId, userId, meetingType: 'visioConference' }))
      return
    }

    if (authUser.status === 'PDS' && authUser.emergencyRoom) {
      dispatch(
        joinMeeting({
          roomOrConsultationId: typeof authUser.emergencyRoom === 'string' ? authUser.emergencyRoom : authUser.emergencyRoom._id,
          userId,
          meetingType: 'visioConference',
        })
      )
      return
    }
  }, [authUser, roomId, consultationId, dispatch])

  useEffect(() => {
    handleJoinMeeting()
    return () => {
      dispatch(leaveMeeting('visioConference'))
    }
  }, [handleJoinMeeting, dispatch])

  return (
    <Stack height="100vh" sx={{ '& > div': { flex: 1 } }}>
      <ChimeMeeting joinMeeting={handleJoinMeeting} disableOpenInNewTab={true} />
    </Stack>
  )
}

export default VisioConferencePage
